module.exports = __webpack_public_path__ + "img/Platform_Gradients-4.fb7d5c38.jpg";